import type { ExtensionsConfigOptions } from '../../types';

export const extConfig: ExtensionsConfigOptions = {
  bold: true,
  italic: true,
  strikethrough: true,
  underline: true,
  bulletList: true,
  orderedList: true,
  horizontalRuler: true,
  link: true,
  emote: true,
  gif: {
    defaultWidth: 780,
    canAlign: true,
    defaultAlignment: 'center',
  },
  deviation: {
    defaultWidth: 780,
    canAlign: true,
    canLink: true,
  },
  deviationThumb: {
    defaultWidth: 150,
    canLink: true,
    maxHeight: 600,
    maxWidth: 780,
  },
  allowUploads: true,
  daVideo: {
    canAlign: true,
    defaultWidth: 780,
    defaultHeight: 438,
  },
  gallery: {
    defaultWidth: 780,
    defaultAlignment: 'center',
    defaultGridItemWidth: 250,
    defaultGridItemHeight: 200,
    defaultLayout: 'grid',
    defaultTorpedoRowHeight: 200,
    defaultLayoutSpacing: 8,
    canLink: true,
  },
  anchor: true,
  spinner: true,
  blockDragging: true,
  blockquote: true,
  heading: true,
  hashtag: true,
  mention: true,
  paste: true,
  textAlignment: true,
  textColor: false,
  textFont: false,
  textHighlight: false,
  history: true,
  indent: {
    captureTab: true,
  },
  muro: true,
  characterCount: false,
};
